/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';

const navigation: FuseNavigationItem[] = [
  {
    id: 'main',
    title: 'Main',
    subtitle: 'Overview',
    type: 'group',
    icon: 'heroicons_outline:home',
    children: [
      {
        id: 'main.dashboard',
        title: 'Dashboard',
        type: 'basic',
        icon: 'heroicons_outline:rectangle-group',
        link: '/dashboard',
      },
      {
        id: 'main.appointments',
        title: 'Appointments',
        type: 'basic',
        icon: 'heroicons_outline:calendar-days',
        link: '/appointments',
        roles: ['admin', 'receptionist', 'doctor'],
      },
      {
        id: 'main.employees',
        title: 'Doctors',
        type: 'basic',
        icon: 'heroicons_outline:identification',
        link: '/employees',
        roles: ['admin', 'receptionist', 'doctor'],
      },
      {
        id: 'main.clients',
        title: 'Clients',
        type: 'basic',
        icon: 'heroicons_outline:user-circle',
        link: '/clients',
        roles: ['admin', 'receptionist', 'doctor'],
      },
    ],
  },

  {
    id: 'clinic',
    title: 'Clinic Centers',
    type: 'group',
    icon: 'heroicons_outline:building-office-2',
    roles: ['admin', 'receptionist', 'doctor'],
    children: [
      {
        id: 'clinic.poles',
        title: 'Clinics',
        type: 'basic',
        icon: 'heroicons_outline:home-modern',
        link: '/poles',
        roles: ['admin', 'receptionist'],
      },
      {
        id: 'clinic.rooms',
        title: 'Rooms',
        type: 'basic',
        icon: 'heroicons_outline:squares-2x2',
        link: '/rooms',
        roles: ['admin', 'receptionist', 'doctor'],
      },
      {
        id: 'clinic.specialities',
        title: 'Specialities',
        type: 'basic',
        icon: 'heroicons_outline:academic-cap',
        link: '/specialities',
        roles: ['admin', 'receptionist'],
      },
    ],
  },

  {
    id: 'financial',
    title: 'Finance',
    type: 'group',
    icon: 'heroicons_outline:banknotes',
    roles: ['admin', 'receptionist', 'doctor'],
    children: [
      {
        id: 'financial.clinic',
        title: 'Clinic Financial',
        type: 'basic',
        icon: 'heroicons_outline:building-office-2',
        link: '/financial/clinic',
        roles: ['admin', 'receptionist'],
      },
      {
        id: 'financial.doctor',
        title: 'Doctor Financial',
        type: 'basic',
        icon: 'heroicons_outline:identification',
        link: '/financial/doctor',
        roles: ['admin', 'receptionist', 'doctor'],
      },
      {
        id: 'financial.global',
        title: 'Global Report',
        type: 'basic',
        icon: 'heroicons_outline:chart-bar',
        link: '/financial/global',
        roles: ['admin'],
      },
      {
        id: 'financial.operational',
        title: 'Operational Report',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/financial/operational',
        roles: ['admin', 'doctor'],
      },
    ],
  },

  {
    id: 'support',
    title: 'Support',
    type: 'group',
    icon: 'heroicons_outline:book-open',
    children: [
      {
        id: 'support.knowledge-base',
        title: 'Knowledge Base',
        type: 'basic',
        icon: 'heroicons_outline:book-open',
        link: '/knowledge-base',
      },
    ],
  },

  {
    id: 'settings',
    title: 'Settings',
    type: 'group',
    icon: 'heroicons_outline:cog-6-tooth',
    roles: ['admin', 'receptionist'],
    children: [
      {
        id: 'settings.users',
        title: 'Users',
        type: 'basic',
        icon: 'heroicons_outline:users',
        link: '/settings/users',
        roles: ['admin', 'receptionist'],
      },
      {
        id: 'settings.roles',
        title: 'Roles',
        type: 'basic',
        icon: 'heroicons_outline:shield-check',
        link: '/settings/roles',
        roles: ['admin', 'receptionist'],
      },
      {
        id: 'settings.terms',
        title: 'Terms & Conditions',
        type: 'basic',
        icon: 'heroicons_outline:document-text',
        link: '/terms-and-conditions',
        roles: ['admin', 'receptionist'],
      },
      {
        id: 'settings.agreements',
        title: 'Therapeutic Agreements',
        type: 'basic',
        icon: 'heroicons_outline:document-check',
        link: '/therapeutic-agreements',
        roles: ['admin', 'receptionist'],
      },
    ],
  },
];


export const defaultNavigation: FuseNavigationItem[] = navigation;
export const compactNavigation: FuseNavigationItem[] = navigation;
export const futuristicNavigation: FuseNavigationItem[] = navigation;
export const horizontalNavigation: FuseNavigationItem[] = navigation;
